/**
 * 自定义全局属性载入
 * @creater liux
 * @Email   liuxing@autobio.com.cn
 * @Date    2019年8月8日 10:00:00
 */

import api from '@/api/api';
import FNs from './fn';
import bus from './bus';
import ajax from './ajax';
import config from './config';
import filters from './filters';
import directives from './directives';
import components from './components';
import userInfo from './userInfo';
import echarts from './echarts';

import _ from 'lodash';

export default {
  install(Vue) {
    //全局方法
    Object.keys(FNs).forEach((key) => {
      Vue.prototype[key] = FNs[key];
    });
    //全局过滤器
    Object.keys(filters).forEach((key) => {
      Vue.filter(key, filters[key]);
    });
    //全局指令
    Object.keys(directives).forEach((key) => {
      Vue.directive(key, directives[key]);
    });
    //全局公共组件
    Object.keys(components).forEach((key) => {
      Vue.component(key, components[key]);
    });
    // 全局组件免引入
    const files = require.context('../component/global', false, /\.(vue|js)$/);
    files.keys().forEach((key) => {
      let componentConfig = files(key); // 获取组件配置
      let componentName = key.replace(/(\.\/|\.vue|\.js)/g, ''); //获取组件的 PascalCase 命名
      Vue.component(componentName, componentConfig.default || componentConfig);
    });
    //中央事件
    Vue.prototype.$bus = bus;
    //ajax请求
    Vue.prototype.$ajax = ajax;

    //js扩展库
    Vue.prototype.$_ = _;
    //内置配置项
    Vue.prototype.$config = Object.assign(config, Vue.prototype.$config || {});
    Vue.prototype.$getConfig = () => {
      //返回promise做回调
      return new Promise((resolve) => {
        resolve(Vue.prototype.$config);
      });
    };
    //user信息操作类
    Vue.prototype.$userInfo = userInfo;
    //api url
    Vue.prototype.$api = api;
    // charts
    Vue.prototype.$chart = echarts;
    Vue.prototype.$addStorageEvent = function (type, key, data) {
      if (type === 1) {
        // 创建一个StorageEvent事件
        let newStorageEvent = document.createEvent('StorageEvent');
        const storage = {
          setItem: function (k, val) {
            localStorage.setItem(k, val);
            // 初始化创建的事件
            newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);
            // 派发对象
            window.dispatchEvent(newStorageEvent);
          }
        }
        return storage.setItem(key, data);
      } else {
        // 创建一个StorageEvent事件
        let newStorageEvent = document.createEvent('StorageEvent');
        const storage = {
          setItem: function (k, val) {
            sessionStorage.setItem(k, val);
            // 初始化创建的事件
            newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);
            // 派发对象
            window.dispatchEvent(newStorageEvent);
          }
        }
        return storage.setItem(key, data);
      }
    }
  },
};
